<template>
    <div class="o-map-exploration-views" >
        <div>
            <BaseView
                v-if="mapViewer.activeView === 'floorView'"
                name="floorView"
                key="floorView"

                :center-on-floors="activeScene.center"
                :center-on-units="centerOnUnits"
                :zoom-on-floors_="activeBuildingFloorsIDs"
                :camera-zoom-margin="getMapConfigProp('map_views.poster.zoom-magin', 0.30)"

                :show-covers="buildingGroupViewCoversBuildingIds"
                :show-outdoor="buildingGroupViewShowOutdoor"
                :show-floors="activeFloorsNames"
                :show-floors-on-start_="allFloorsUnitNames"

                :tilt-floors="tiltFloors"
                :shift-floors="shiftFloors"

                :fade-out-floors-except="activeBuildingFloorsIDs"

                :highlight-floor-walls="floorsWallsHighlightColors"

                :transparent-covers="buildingIds"
                :transparent-floors="activeBuildingGroupTransparentFloorsUnitNames"

                :camera-orientation="activeScene.orientation"
                :camera-tilt="activeScene.tilt"

                :zoom="activeScene.zoom"

                :transition-duration="activeSceneDuration"

                :separate-floors="activeBuildingGroupSeparateFloors"

                :limit-max-zoom-to="getMapConfigProp('map_views.default.max_zoom',12000)"
                :max-zoom-margin="getMapConfigProp('map_views.poster.max_zoom_magin', 0.5)"
                :highlight-units="unitsHighlightColors"

                :limit-min-zoom-to="getMapConfigProp('map_views.default.limit_min_zoom_too', 100)"
                :transition-duration_="transitionDuration"

                :stop-rendering-on-transition-end="getMapConfigProp('map_views.poster.stop_rendering', false)"
                :stop-rendering-delay="getMapConfigProp('map_views.poster.stop_rendering_delay', 5000)"

                @transitionEnd="nextScene"
            >

            </BaseView>
        </div>

        <div class="hover-labels ui-map-labels" v-if="isActive">
            <div v-if="aMapBuildNumbersParams.params && aMapBuildNumbersParams.params.is_show">
                <MapLabel
                    v-for="(tenant, i) in activeBuildingGroupTenantsWithUnitAliases"
                    :key="tenant.unit.name + i"
                    :selectedUnit="tenant.unit.name"
                    :target-floor="tenant.floor.unit_name"
                    :target-coordinates="getTargetCoordinates(tenant)"
                    target="unit"
                    :offsetX="0"
                    :offsetY="0"
                    position-x="middle"
                    position-y="middle"
                >
                    <div
                        class="map-build-number"
                        :style="aMapBuildNumbersParams.styles"
                    >{{ getObjectUnitDataView(tenant) || ''  }}</div>
                </MapLabel>
            </div>

            <div v-if="activeFloorsPortalsLines.length && activeView == 'floorView'">
                <!-- Portals lines -->

                <MapLabel
                    v-for="portalLine in activeFloorsPortalsLines"
                    :key="portalLine.startUnit"
                    :selectedUnit="portalLine.startUnit"
                    target="unit"
                    :offsetX="0"
                    :offsetY="0"
                    position-x="middle"
                    position-y="middle"
                    :style="{width: '1px'}"
                >
                    <OUnitsLine
                        :style="aMapUnitPortalLine.styles"
                        :start-unit="portalLine.startUnit"
                        :finish-unit="portalLine.finishUnit"
                        :animation="aMapUnitPortalLine.params.animation"
                    />
                </MapLabel>
            </div>

            <!-- tenats anchor label -->

            <div v-if="aTenantsLabels.params.is_show">
                <MapLabel
                    v-for="tenant in tenantsLabels"
                    :key="tenant.unit.name"
                    :selectedUnit="tenant.unit.name"
                    target="unit"
                    :offsetX="0"
                    :offsetY="0"
                    position-x="middle"
                    position-y="middle"
                >
                    <img
                        class="tenants-icon"
                        :src="tenant.files.icon || tenant.files.icon2"
                        alt="tenants icon"
                        :style="aTenantsLabels.styles"
                    >
                </MapLabel>
            </div>

            <div>
                <!-- Portals icons -->
                <MapLabel
                    v-for="(tenant, i) in activeFloorsPortals"
                    :key="tenant.unit.name + i"
                    :selectedUnit="tenant.unit.name"
                    target="unit"
                    :offsetX="0"
                    :offsetY="0"
                    position-x="middle"
                    position-y="middle"
                >
                    <div
                        class="floor-portal-icon"
                        :style="{
                            ...aPFloorPortalIcon.styles,
                            ...portalIcon
                        }"
                    ></div>
                </MapLabel>
            </div>

            <!-- portal figures -->
            <div>
                <OFloorCover
                    v-if="componentParams.is_show_floor_cover"
                />
                <OUnitsFigures/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import OUnitsLine from "../o-units-line/o-units-line"
import OFloorCover from "../o-floor-cover/o-floor-cover"
import OUnitsFigures from "../o-units-figures/o-units-figures"
import MapLabel from "../../../shared/components/map-viewer/labels/map-label"
import BaseView from "../../../shared/components/map-viewer/views/base/base-view"

import {arrayValues2ObjectKeys, objects2UnitColors} from "@/utils/helpers/common";

export default {
    name: "OMapPosterViews",
    components: {
        BaseView,
        MapLabel,
        OUnitsLine,
        OFloorCover,
        OUnitsFigures,
    },

    // -------------------------------- Injected ----------------------------------------
    inject: ['mapViewer'],

    // -------------------------------- Data --------------------------------------------
    data(){
        return {
            prevActiveView: 'OutdoorView',
            activeBuildingIds: [],
            activeLevel: null,

            selectedObjects: [],

            hoveredFloorUnitName: null,

            transitionDuration: 1.2,
            separateDistance: 35,

            prevViewFloorsUnitNames: [],

            aPFloorPortalIcon: {},
            aMapBuildNumbersParams: {},
            aMapUnitPortalLine: {},
            aTenantsLabels: {},

            startScene: true,
            activeSceneIndex: 0
        }
    },

    // -------------------------------- Computed ----------------------------------------
    computed: {
        ...mapGetters([
            't',
            'getUnit',
            'getObjectIndex',
            'getMapConfigProp',
            'getObjectFloorIndex',
            'getDenormalisedTerminal',
            'getDenormalisedObjectById'
        ]),
        isActive(){
            return [
                'floorView',
                'OutdoorView'
            ].includes(this.activeView)
        },
        emptyArray(){
            return []
        },
        activeView(){
            return this.mapViewer.activeView;
        },
        md(){
            return this.mapViewer.mapData
        },
        activeFloor(){
            return this.floors.find( f => this.activeBuildingIds.includes(f.meta.building_index) && f.meta.level === this.activeLevel)
        },
        activeFloorUnitNames(){
            return this.activeFloor ? [this.activeFloor.unit.name] : this.emptyArray
        },
        verticalDistanceBetweenFloors(){
            return this.getMapConfigProp('map_views.building_floors.floors.vertical_distance_between_floors', 115);
        },

        visibleFloorsUnitNames(){
            return [
                ...this.activeBuildingGroupFloorsUnitNames,
                ...this.outdoorFloorsUnitNames,
            ]
        },
        buildingGroupViewVisibleFloorsUnitNames(){
            const floors = [];
            floors.push(...this.activeBuildingGroupFloorsUnitNames);

            this.getBgViewConfig('show_outdoor', false) &&
                floors.push(...this.outdoorFloorsUnitNames);

            return floors;
        },
        buildingGroupViewCoversBuildingIds(){
            return this.getBgViewConfig('show_outdoor', false) ? this.nonActiveBuildingGroupBuildingIDs : [];
        },
        buildingGroupViewShowOutdoor(){
            return this.getBgViewConfig('show_outdoor', false)
        },

        floorViewVisibleFloorsUnitNames(){
            const floors = [];

            floors.push(...this.activeBuildingGroupLevelFloorsUnitNames);

            if(  this.getFloorViewConfig('floors.above', false) ){
                floors.push(...this.activeBuildingGroupFloorsUnitNames);
            }
            if(  this.getFloorViewConfig('floors.below', false) ){

                const activeLevel = this.activeLevel;
                const belowFloors = this.activeBuildingGroupFloors.filter( f => f.meta.level < activeLevel);
                floors.push(...belowFloors.map( f => f.unit.name));
            }

            this.getFloorViewConfig('floors.outdoor', false) &&
                floors.push(...this.outdoorFloorsUnitNames);

            return floors;
        },
        floorViewCoversBuildingIds(){
            return this.getFloorViewConfig('show_outdoor', false) ? this.nonActiveBuildingGroupBuildingIDs : [];
        },
        floorViewShowOutdoor(){
            return this.getFloorViewConfig('show_outdoor', false)
        },

        activeBuildings(){
            return this.buildings.filter( b => this.activeBuildingIds.includes(b.meta.building_index))
        },
        activeBuildingOrientation(){
            return this.activeBuilding?.meta.camera_rotation || this.getExploreConfig('orientation',0);
        },
        activeBuildingGroupIds(){
            return this.activeBuildings?.map(b => b?.meta.building_group_id);
        },
        activeBuildingFloors(){
            return this.floors.filter( f => this.activeBuildingIds.includes(f.meta.building_index))
        },
        activeBuildingFloorsIDs(){
            return this.activeBuildingFloors.map( f => f.unit.name)
        },
        activeBuildingGroupBuildings(){
            // b.meta.building_group_id === this.activeBuilding.meta.building_group_id
            return this.activeBuildings ? this.buildings.filter( b => this.activeBuildings.some(ab => b.meta.building_group_id === ab.meta.building_group_id)) : this.emptyArray
        },
        activeBuildingGroupBuildingIDs(){
            return this.activeBuildingGroupBuildings.map( b => b.meta.building_index)
        },
        activeBuildingGroupFloors(){
            return this.activeFloors.filter( f => this.activeBuildingGroupIds.includes(f.floor.building_group_id));
        },
        activeBuildingGroupTenants(){
            const bgIds = this.activeBuildingGroupIds;
            return this.tenants.filter( f => bgIds.includes(f.floor.building_group_id) && this.activeLevels.includes(f.floor.level));
        },
        activeBuildingGroupTenantsWithUnitAliases(){
            return _.uniqBy(
                this.activeBuildingGroupTenants.filter( t => t.unit.alias),
                'unit.alias'
            );
        },
        tenantsLabels() {
            return this.activeBuildingGroupTenants.filter( t => t.meta.anchor && t.files.icon2);
        },
        activeBuildingGroupOneUnitNamePerFloor(){
            const floorsUnitNames = this.activeBuildingGroupFloorsUnitNames;

            return this.portals.reduce( (acc, p) => {
                if(!acc[p.floor.id]){
                    acc[p.floor.id] = p.unit.name;
                }
                return acc;
            }, {})
        },
        activeBuildingGroupLevelFloors(){
            const activeLevel = this.activeLevel;
            return this.activeBuildingGroupFloors.filter( f => f.meta.level === activeLevel);
        },
        activeBuildingGroupLevelFloorsUnitNames(){
            return this.activeBuildingGroupLevelFloors.map( f => f.unit.name );
        },
        activeBuildingGroupFloorsUnitNames(){
            return this.activeBuildingGroupFloors.map( f => f.unit.name );
        },
        activeBuildingGroupSeparateFloors(){
            const min = this.activeBuildingGroupMinEntranceLevels;
            const activeLevelSeparateDistance = this.getFloorViewConfig('rise_above_floors',0);
            const separapeFromConfig = this.getMapConfigProp('map_views.poster.floors_separate_distance',  false)

            return separapeFromConfig || this.activeBuildingGroupFloors.reduce( (acc, f) => {
                if(f.floor.level > this.activeLevel && this.activeView === 'LevelView'){
                    acc[`${f.unit.name}`] = (f.floor.level - min) * this.verticalDistanceBetweenFloors + activeLevelSeparateDistance;
                }
                else
                {
                    acc[`${f.unit.name}`] = (f.floor.level - min) * this.verticalDistanceBetweenFloors;
                }
                return acc;
            }, {} );
        },
        activeBuildingGroupLevels(){
            return _.uniq(
                this.activeBuildingGroupFloors.map( f => f.meta.level)
            );
        },
        activeBuildingGroupMinLevel(){
            return Math.min(...this.activeBuildingGroupLevels);
        },
        activeBuildingGroupMaxLevel(){
            return Math.max(...this.activeBuildingGroupLevels);
        },
        activeBuildingGroupAvgLevel(){
            return Math.round(this.activeBuildingGroupMinLevel + (this.activeBuildingGroupMaxLevel - this.activeBuildingGroupMinLevel) / 2 );
        },
        activeBuildingGroupAvgLevelFloors(){
            const avgLevel = this.activeBuildingGroupAvgLevel;
            return this.activeBuildingGroupFloors.filter( f => f.meta.level === avgLevel);
        },
        activeBuildingGroupAvgLevelFloorsUnitNames(){
            return this.activeBuildingGroupAvgLevelFloors.map( f => f.unit.name );
        },
        activeBuildingGroupEntranceLevels(){
            const ids = this.activeBuildingGroupBuildingIDs;
            return _.uniq(
                this.entrances.reduce( (acc, p) => {
                    ids.includes(p.floor.building_index) && acc.push(p.floor.level);
                    return acc;
                }, [])
            );
        },
        activeBuildingGroupGroundLevels(){
            const ids = this.activeBuildingGroupBuildingIDs;
            return _.uniq(
                this.groundFloors.reduce( (acc, f) => {
                    ids.includes(f.meta.building_index) && acc.push(f.meta.level);
                    return acc;
                }, [])
            );
        },
        activeBuildingGroupMinEntranceLevels(){
            return Math.min(...this.activeBuildingGroupEntranceLevels, ...this.activeBuildingGroupGroundLevels );
        },
        activeBuildingGroupMaxEntranceLevels(){
            return Math.max(...this.activeBuildingGroupEntranceLevels);
        },
        activeBuildingGroupHasUnderground(){
            return this.activeBuildingGroupLevels.some( l => l < this.activeBuildingGroupMinEntranceLevels);
        },
        activeBuildingGroupTransparentFloors(){
            return this.activeBuildingGroupHasUnderground ? this.outdoorFloors : [];
        },
        activeBuildingGroupTransparentFloorsUnitNames(){
            return this.activeBuildingGroupTransparentFloors.map( f => f.unit.name);
        },
        nonActiveBuildingGroupBuildings(){
            return this.activeBuilding ? this.buildings.filter( b => b.meta.building_group_id !== this.activeBuilding.meta.building_group_id) : this.emptyArray
        },
        nonActiveBuildingGroupBuildingIDs(){
            return this.nonActiveBuildingGroupBuildings.map( b => b.meta.building_index)
        },
        activeBgFloorsObjects(){
            const bgFloorsIds = this.activeBuildingFloorsIDs;
            return this.objects.filter( o => bgFloorsIds.includes(o.floor.unit.name) );
        },
        activeBgLevelObjects(){
            return this.activeBgFloorsObjects.filter( o => o.floor.level === this.activeLevel );
        },
        activeBgFloorsLabels(){
            return this.activeBgFloorsObjects.filter( o => o.type === 'label' );
        },
        activeBgFloorsAnchors(){
            return this.activeBgFloorsObjects.filter( o => o.meta.anchor );
        },
        activeBgFloorsIcons(){
            const icons = [];

            this.getBgViewConfig('icons.anchors', false) &&
                icons.push(...this.activeBgFloorsAnchors.map( obj => {
                    switch (obj.type){
                        case 'portal':
                        case 'label':
                            return `${obj.id}--${obj.unit.name}`;
                            break;
                        case 'tenant':
                        case 'service':
                            // acc.push(obj.id);
                            return `tenant-icon-${obj.id}-${obj.unit.name}`;
                            break;
                    }
                }));

            this.getBgViewConfig('icons.labels', false) &&
                icons.push(...this.activeBgFloorsLabels.map( obj => `${obj.id}--${obj.unit.name}` ));

            return icons
        },
        activeLevelFloors(){
            return this.floors.filter( f => f.meta.level === this.activeLevel && this.activeBuildingGroupBuildingIDs.includes(f.meta.building_index))
        },
        levelViewIcons(){
            // load active bg level icons

            const hideAll = this.getFloorViewConfig('icons.hide_all', false);
            if(hideAll){
                return false;
            }

            const afAnchors = this.getFloorViewConfig('icons.active_floor_anchors', true);
            const afLabels = this.getFloorViewConfig('icons.active_floor_labels', true);
            const afSelected = this.getFloorViewConfig('icons.active_floor_selected', true);
            const afOther = this.getFloorViewConfig('icons.active_floor_other', true);

            const icons = this.activeBgLevelObjects.reduce( (acc, obj) => {
                switch (obj.type){
                    case 'portal':
                    case 'label':
                        afLabels &&
                            acc.push(`${obj.id}--${obj.unit.name}`);
                        break;
                    case 'tenant':
                    case 'service':
                        (   afOther ||
                            afAnchors && obj.meta.anchor ||
                            afSelected && this.selectedObjectsIds.includes(obj.id)
                        ) &&
                            acc.push(`tenant-icon-${obj.id}-${obj.unit.name}`);
                        break;
                }
                return acc;
            }, []);

            this.getFloorViewConfig('icons.other_floors_anchors', false) &&
                icons.push(...this.activeBgFloorsAnchors.map( obj => {

                    switch (obj.type){
                        case 'portal':
                        case 'label':
                            return `${obj.id}--${obj.unit.name}`;
                            break;
                        case 'tenant':
                        case 'service':
                            // acc.push(obj.id);
                            return `tenant-icon-${obj.id}-${obj.unit.name}`;
                            break;
                    }

                }));

            this.getFloorViewConfig('icons.other_floors_labels', false) &&
                icons.push(...this.activeBgFloorsLabels.map( obj => `${obj.id}--${obj.unit.name}` ));

            return icons
        },

        activeLevelFloorIDs(){
            return this.activeLevelFloors.map( f => f.unit.name )
        },
        outdoorBuildingsIDs(){
            return this.buildings.filter( b => b.meta.is_outdoor)
        },
        outdoorFloors(){
            return this.floors.filter( f => f.meta.is_outdoor)
        },
        outdoorFloorsUnitNames(){
            return this.outdoorFloors.map( f => f.unit.name)
        },

        levelViewFloorIDs(){
            return this.activeLevel === 0 ? [...this.activeLevelFloorIDs, ...this.outdoorFloorsUnitNames] : this.activeLevelFloorIDs
        },

        levels(){
            return Array.from(this.floors.reduce((acc,f) => acc.add(f.meta.level), new Set()));
        },
        floors(){
            return this.mapViewer.mapData.objects.filter( o => o.type === 'floor');
        },
        activeLevels() {
            return this.getMapConfigProp('map_views.poster.active_levels', []);
        },
        activeFloors() {
            return this.floors.filter(floor => this.activeBuildingIds.includes(floor.meta.building_index) && this.activeLevels.includes(floor.meta.level))
        },
        tiltFloors() {
            return this.getMapConfigProp('map_views.poster.tilt_floor', {});
        },
        shiftFloors() {
            return this.getMapConfigProp('map_views.poster.shift_floor', {});
        },
        activeFloorsNames() {
            return this.activeFloors.map(f => f.unit.name)
        },
        allFloorsUnitNames(){
            return this.floors.map( f => f.unit.name)
        },
        activeFloorsPortals() {
            const excludeUnits = this.getMapConfigProp('components.AMapUnitPortalLine.params.exclude_portal_icon_ids', [])
            return this.portals.filter(portal =>
                this.activeFloorsNames.includes(portal.floor.unit_name)
                && portal.meta.portal_direction == "Both"
                && portal.meta.portal_type == "Elevators"
                && !excludeUnits.includes(portal.unit.id)
            )
        },
        filtredActiveFloorsPortals() {
            const excludeUnits = this.getMapConfigProp('components.AMapUnitPortalLine.params.exclude_line_lift', [])
            return this.activeFloorsPortals.filter(({unit: {id}}) => !excludeUnits.includes(id))
        },
        activeFloorsPortalsLines() {
            const portalsUnits = []
            const groupedPortals = _.groupBy(this.filtredActiveFloorsPortals, 'id')
            Object.values(groupedPortals).forEach(portals => {
                const sortedPortals = portals.sort((a, b) => a.floor.level > b.floor.level ? 1 : -1)
                sortedPortals.forEach((portal, i, arr) => {
                    if(arr.length -1 > i) {
                        portalsUnits.push({
                            startUnit: portal.unit.name,
                            finishUnit: arr[i + 1].unit.name
                        })
                    }
                })
            })

            return portalsUnits
        },
        objects(){
            return this.mapViewer.mapData.objects;
        },
        tenants(){
            return this.objects.filter( o => o.type === 'tenant');
        },
        services(){
            return this.objects.filter( o => o.type === 'service');
        },
        anchorTenants(){
            return this.tenants.filter( o => o.meta.anchor );
        },

        anchorServices(){
            return this.services.filter( o => o.meta.anchor );
        },
        anchorTenantUnitNames(){
            return this.anchorTenants.map( obj => obj.unit.name );
        },
        anchorServicesUnitNames(){
            return this.anchorServices.map( obj => obj.unit.name );
        },

        units(){
            return this.mapViewer.mapData.units;
        },
        unitNames(){
            return this.units.map( u => u.name);
        },
        portals(){
            return this.mapViewer.mapData.objects.filter( o => o.type === 'portal');
        },
        entrances(){
            return this.portals.filter( p => p.meta.is_entrance )
        },
        groundFloors(){
            return this.floors.filter( f => f.meta.is_ground )
        },
        buildings(){
            return this.mapViewer.mapData.objects.filter( o => o.type === 'building');
        },
        hoverableObjects(){
            return this.mapViewer.mapData.objects.filter( o => ['tenant', 'service', 'portal', 'floor', 'building'].includes(o.type));
        },
        indoorBuildings(){
            return this.buildings.filter( o => !o.meta.is_outdoor);
        },
        buildingIds(){
            return this.buildings.map( b => b.meta.building_index)
        },

        targetZoneServices(){
            const tzCatId = this.getMapConfigProp('categories.target_zone_service_category')
            if(!tzCatId){
                // TODO: Add/replace with sentry logging
                console.error('Target zone category is not defined. Set it in map settings `categories.target_zone_service_category`')
                return this.emptyArray
            }
            return this.md.objects.filter( o => o.type === 'service' && o.lists.categories && o.lists.categories.includes(tzCatId) && !this.activeLevelFloorIDs.includes(o.floor.unit_name) && o.files.icon )
        },
        targetZoneServicesUnitNames(){
            return this.targetZoneServices.map( o => o.unit.name )
        },

        activeLevelPortals(){
            return this.portals.filter( p => this.activeLevelFloorIDs.includes(p.floor.unit_name) )
        },
        activeBuildingPortals(){
            return this.portals.filter( p => this.activeBuildingIds.includes(p.floor.building_index) && p.meta.portal_type === 'Elevators' )
        },

        activeLevelElevatorPortals(){
            return this.activeLevelPortals.filter( p => p.meta.portal_type === 'Elevators' )
        },

        selectedObjectsIds(){
            return Array.from( this.selectedObjects.reduce( (acc,o) => acc.add(o.id), new Set ) )
        },
        floorUnirColor() {
            if(!_.isEmpty(this.floorColor)) {
                return Object.fromEntries(this.units
                    .filter(unit => this.floorColor[unit.floor.level])
                    .map(unit => [unit.name, this.floorColor[unit.floor.level]])
                )
            }
            return {}
        },
        unitsColors(){
            const color = this.getMapConfigProp(`map_views.default.units.color`);
            return color ? arrayValues2ObjectKeys(this.unitNames, color) : {};
        },
        selectedObjectsUnitsColor(){
            const selectedColor = this.getMapConfigProp(`map_views.default.units.selected_color`);
            return selectedColor ? objects2UnitColors(this.selectedObjects, 'selected_color', selectedColor) : {};
        },
        objectUnitColors(){
            const color = this.getMapConfigProp(`map_views.default.units.color`);
            return color ? objects2UnitColors(this.selectedObjects, 'color', color) : {};
        },

        anchorTenantUnitsColors(){
            const color = this.getMapConfigProp(`map_views.default.units.anchor_tenant_color`) ||
                this.getMapConfigProp(`map_views.default.units.anchor_color`);
            return objects2UnitColors(this.anchorTenants, 'anchor_color', color);
        },
        anchorServicesUnitsColors(){
            const color = this.getMapConfigProp(`map_views.default.units.anchor_service_color`) ||
                this.getMapConfigProp(`map_views.default.units.anchor_color`);
            return objects2UnitColors(this.anchorServices, 'anchor_color', color);
        },

        hoveredFloor(){
            return this.floors.find( f => f.unit.name === this.hoveredFloorUnitName )
        },
        showOutdoor(){
            return this.activeLevel === null || this.getMapConfigProp('global_map.outdoor_levels', [0]).includes(this.activeLevel)
        },
        floorColor() {
            return this.getMapConfigProp(`map_views.poster.floor_color`, {})
        },
        unitsHighlightColors(){
            return _.merge(
                {},
                this.unitsColors,
                this.objectUnitColors,
                this.anchorTenantUnitsColors,
                this.anchorServicesUnitsColors,
                this.selectedObjectsUnitsColor,
                this.floorUnirColor,
                this.customUnitColors,
            )
        },
        customUnitColors(){
            return this.getMapConfigProp(`map_views.default.units.units_colors`, {});
        },
        indoorFloors(){
            return this.floors.filter( f => !f.meta.is_outdoor );
        },
        indoorFloorsUnitNames(){
            return this.indoorFloors.map( f => f.unit.name )
        },
        floorsWallsHighlightColors(){
            const defaultDetailsColor =  this.getMapConfigProp(`floors.default.walls_color`);
            const floorsDetailsColor = {};

            this.indoorFloorsUnitNames.reduce((acc, floorUnitName) => {
                const floorUseVertexColor = this.getMapConfigProp(`floors.${floorUnitName}.use_vertex_colors`, null);
                if(floorUseVertexColor){
                    return acc;
                }

                const floorDetailsColor = this.getMapConfigProp(`floors.${floorUnitName}.walls_color`, null);
                if(floorDetailsColor){
                    acc[floorUnitName] = floorDetailsColor;
                }
                else if(defaultDetailsColor && floorDetailsColor === null){
                    acc[floorUnitName] = defaultDetailsColor
                }
                return acc;
            }, floorsDetailsColor);

            return floorsDetailsColor;
        },
        defaultScene() {
            return this.getMapConfigProp('map_views.poster.default_scene', {
                "center": [
                ],
                "zoom": 1800,
                "tilt": 30,
                "orientation": -27,
                "duration": 500
            })
        },
        scenes(){
            return this.getMapConfigProp('map_views.poster.scenes', []);
        },
        activeScene(){
            const isAnimation = this.getMapConfigProp('map_views.poster.animation', false);
            if(isAnimation) return _.merge(this.defaultScene, this.scenes[this.activeSceneIndex]);
            else return this.defaultScene
        },
        activeSceneDuration(){
            return this.startScene ? 0 : this.activeScene.duration;
        },
        portalIcon() {
            const configIcon = this.mapViewer.mapData.config.icons.find(i => i.resource_id === 'elevators') || 'https://fs.mvgcloud.com/24597931/64566733/44212890/47323777.png'
            return {backgroundImage: `var(--floor-portal-icon__background-image, url(${configIcon}))`}
        },
        centerOnUnits() {
            return this.getMapConfigProp('map_views.poster.center-on-units', [])
        },
        componentParams() {
            return this.getMapConfigProp(`components.OMapPosterViews.params`) || {};
        }
    },

    // -------------------------------- Methods ---------------------------------------
    methods: {
        getUnitOffsetWithLevelShift(level, relativeToFloorPointOffset){
            const floorOffset = this.shiftFloors[level] || {};
            return {
                x: relativeToFloorPointOffset.x,
                y: relativeToFloorPointOffset.y,
                z: relativeToFloorPointOffset.z,
            };
            //return _.mergeWith(relativeToFloorPointOffset, floorOffset, _.add);
        },
        goToBuildingFloorsView(level = null){
            this.activeLevel = level !== null ? level : this.activeBuildingGroupAvgLevel;
        },
        getExploreConfig(prop, def){
            return _.get( this.mapViewer.mapData.config, `explore_camera.${prop}`, def);
        },
        getBgViewConfig(prop, def){
            return this.getMapConfigProp(`map_views.building_group.${prop}`, def)  || this.getMapConfigProp(`map_views.default.${prop}`, def);
        },
        getFloorViewConfig(prop, def){
            return this.getMapConfigProp(`map_views.floor.${prop}`, def)  || this.getMapConfigProp(`map_views.default.${prop}`, def);
        },
        getComponentsParams(componentName) {
            return {
                styles: {
                    ...this.getMapConfigProp(`components.${componentName}.styles`),
                    ...this.getMapConfigProp(`views.${this.view}.${componentName}.styles`)
                },
                params: {
                    ...this.getMapConfigProp(`components.${componentName}.params`),
                    ...this.getMapConfigProp(`views.${this.view}.${componentName}.params`)
                }
            }
        },
        nextScene(){
            if(this.activeSceneIndex + 1 < this.scenes.length)
            {
                this.activeSceneIndex++;
            }
            else
            {
                this.activeSceneIndex = 0;
            }

            if(this.startScene)
            {
                this.startScene = false;
            }
        },
        getTargetCoordinates(tenant) {
            const placementPoints = tenant.unit.placement_points;
            let placementFloorOffset = null;

            // if(placementPoints.length) {
            //     const activeIcon = tenant.meta.icons2[tenant.unit.name];
            //     if(activeIcon) {
            //         const activePlacementPoints = placementPoints.find(({props}) => {
            //             const unitOffset = props.unit_offset;
            //             return activeIcon.icon_position_x == unitOffset.x && activeIcon.icon_position_z == unitOffset.z
            //         })

            //         if(activePlacementPoints) {
            //             placementFloorOffset = activePlacementPoints.props.floor_offset;
            //         }
            //     }
            // }
            if(placementPoints.length) {
                const activePlacementPoints = placementPoints.find(point => point.props.is_default && point.type === 'index')
                
                if(activePlacementPoints) {
                    placementFloorOffset = activePlacementPoints.props?.floor_offset;
                }
            }
            return placementFloorOffset || tenant.unit.alias_offset;
        },
        getObjectUnitDataView(item) {
            const method = this.componentParams.unit_data_view || 'getObjectAlias';

            return this[method](item)
        },
        getObjectAlias(item) {
            return item.unit.alias || ''
        }
    },

    // -------------------------------- Watch ---------------------------------------

    watch:{
        activeView(view, oldView){
            if(view === 'floorView' && oldView !== 'floorView') {
                const level = this.getMapConfigProp('map_views.building_floors.active_level');
                this.goToBuildingFloorsView(level);

                this.prevActiveView = oldView;
            }
        },
        visibleFloorsUnitNames(){
            this.prevViewFloorsUnitNames = this.allFloorsUnitNames;
        }
    },

    // -------------------------------- Hooks ---------------------------------------

    created() {
        this.activeBuildingIds = this.getMapConfigProp('map_views.poster.active_building_ids', []);
        this.aPFloorPortalIcon = this.getComponentsParams('APFloorPortalIcon', {params: {}, styles: {}});
        this.aMapBuildNumbersParams = this.getComponentsParams('AMapBuildNumbers', {params: {}, styles: {}});
        this.aMapUnitPortalLine = this.getComponentsParams('AMapUnitPortalLine', {params: {}, styles: {}});
        this.aTenantsLabels = this.getComponentsParams('TenantsLabels', {params: {}, styles: {}});
    },
    mounted() {
        if(this.activeView === 'floorView') {
            const level = this.getMapConfigProp('map_views.poster.active_level');
            this.goToBuildingFloorsView(level);
        }
    },
}
</script>
<style lang="scss">
  @import "o-map-poster-views";
</style>

